import { useMutation } from '@apollo/client';

import {
  StopPaymentMutation,
  StopPaymentMutationVariables,
} from '../graphql/generated';
import { STOP_PAYMENT } from '../graphql/mutations';

const useStopPayment = () => {
  const [stopPayment, result] = useMutation<
    StopPaymentMutation,
    StopPaymentMutationVariables
  >(STOP_PAYMENT);

  return {
    stopPayment,
    ...result,
  };
};

export default useStopPayment;
